// validaciones.js

export const validarEstudiante = (data) => {
  const errors = {};

  // Step 1: Datos personales
  if (!data.name?.trim()) errors.name = "El nombre es obligatorio";
  else if (data.name.length > 100) errors.name = "Máximo 100 caracteres";

  if (!data.apellido_paterno?.trim()) errors.apellido_paterno = "El apellido paterno es obligatorio";
  else if (data.apellido_paterno.length > 100) errors.apellido_paterno = "Máximo 100 caracteres";

  if (data.apellido_materno && data.apellido_materno.length > 100)
    errors.apellido_materno = "Máximo 100 caracteres";

  if (!data.ci?.trim()) errors.ci = "El CI es obligatorio";
  else if (!/^\d+$/.test(data.ci)) errors.ci = "El CI debe ser numérico";

  if (!data.expedido) errors.expedido = "Debe seleccionar un departamento de expedición";
  // Tipo de sangre
  if (!data.tipo_sangre) {
    errors.tipo_sangre = "Debe seleccionar el tipo de sangre";
  }

  // Lugar de nacimiento
  if (!data.lugar_nacimiento) {
    errors.lugar_nacimiento = "Debe seleccionar el lugar de nacimiento";
  }

  // País
  if (!data.pais) {
    errors.pais = "Debe seleccionar un país";
  }

  // Si selecciona OTROS debe escribir el país
  if (data.pais === "OTROS") {
    if (!data.pais_otro?.trim()) {
      errors.pais_otro = "Debe especificar el país";
    } else if (data.pais_otro.length > 100) {
      errors.pais_otro = "Máximo 100 caracteres";
    }
  }

  // Departamento
  if (!data.departamento) {
    errors.departamento = "Debe seleccionar un departamento";
  }

  // Provincia
  if (!data.provincia?.trim()) {
    errors.provincia = "La provincia es obligatoria";
  } else if (data.provincia.length > 100) {
    errors.provincia = "Máximo 100 caracteres";
  }

  if (!data.celular?.trim()) errors.celular = "El celular es obligatorio";
  else if (!/^\d{8,10}$/.test(data.celular)) errors.celular = "Celular inválido";

  if (!data.email || !data.email.trim()) {
    errors.email = "El email es obligatorio";
  } else {
    const email = data.email.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      errors.email = "Email inválido";
    }
  }

  if (!data.fecha_cumpleaños) errors.fecha_cumpleaños = "Debe ingresar fecha de nacimiento";
  else {
    const nacimiento = new Date(data.fecha_cumpleaños);
    if (nacimiento > new Date()) errors.fecha_cumpleaños = "Fecha inválida";
  }

  // Step 2: Información adicional (comentadas en tu código original)
  if (data.estado && !["por_iniciar", "activo", "inactivo", "abandonado", "finalizado"].includes(data.estado))
    errors.estado = "Estado inválido";

  if (data.celular_referencia?.trim() === "") errors.celular_referencia = "El celular de referencia es obligatorio";
  else if (data.celular_referencia?.length > 20) errors.celular_referencia = "Máximo 20 caracteres";

  if (data.referencia_nombre?.trim() === "") errors.referencia_nombre = "El nombre de referencia es obligatorio";
  else if (data.referencia_nombre?.length > 100) errors.referencia_nombre = "Máximo 100 caracteres";

  if (data.referencia_relacion?.trim() === "") errors.referencia_relacion = "La relación con la referencia es obligatoria";
  else if (data.referencia_relacion?.length > 50) errors.referencia_relacion = "Máximo 50 caracteres";

  if (data.como_se_entero?.trim() === "") errors.como_se_entero = "El campo 'Cómo se enteró' no puede estar vacío";

  if (data.observaciones && data.observaciones.trim() === "") errors.observaciones = "Si ingresa observaciones, no pueden estar vacías";

  if (!data.a_nombre_factura?.trim()) errors.a_nombre_factura = "Debe ingresar el nombre para la factura";
  else if (data.a_nombre_factura?.length > 100) errors.a_nombre_factura = "Máximo 100 caracteres";

  // Step 3: Inscripción

  // Step 4: Pagos
  const hayMonto = data.monto_pago !== undefined && data.monto_pago !== null && data.monto_pago !== "";
  if (hayMonto) {
    if (isNaN(data.monto_pago) || Number(data.monto_pago) < 0)
      errors.monto_pago = "El monto debe ser un número válido";
    if (!data.concepto_pago?.trim()) errors.concepto_pago = "Debe ingresar un concepto de pago";
    if (!data.fecha_pago) errors.fecha_pago = "Debe ingresar una fecha de pago";
  }

  return errors; // Devuelve todos los errores
};
